import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatToolbarModule } from '@angular/material/toolbar';
import { IntakeEvictionService } from './services/intake-eviction.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EvictionIntakeModule } from '@ee/common/eviction-intake';
import { MatIconModule } from '@angular/material/icon';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideSingleVisibleDialog, WafTokenInterceptor } from '@ee/common/services';
import { LoadingModule } from '@ee/common/loading';
import { LayoutModule } from '@angular/cdk/layout';
import { MatLuxonDateModule } from '@angular/material-luxon-adapter';
import { popperVariation, provideTippyConfig, provideTippyLoader } from '@ngneat/helipopper/config';
import { promoteTooltipAboveCdkOverlay } from '@ee/common/utils';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { EE_LUXON_DATE_FORMATS } from '@ee/common/constants';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    MatToolbarModule,
    RouterModule.forChild([]),
    EvictionIntakeModule.forRoot(environment),
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatLuxonDateModule,
    MatListModule,
    LoadingModule,
    LayoutModule
  ],
  providers: [
    provideSingleVisibleDialog(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    IntakeEvictionService,
    { provide: MAT_DATE_FORMATS, useValue: EE_LUXON_DATE_FORMATS },
    provideTippyLoader(() => import('tippy.js')),
    provideTippyConfig({
      // A tooltip anchored inside a CDK overlay renders behind it: since Angular 21 the CDK attaches
      // overlays with popover="manual", putting them in the browser top layer, which no z-index can
      // reach. This promotes such a tooltip into the top layer too. No-op for every other tooltip.
      onMount: promoteTooltipAboveCdkOverlay,
      defaultVariation: 'tooltip',
      variations: {
        tooltip: {
          theme: null,
          arrow: true,
          animation: 'scale',
          trigger: 'mouseenter',
          offset: [0, 5]
        },
        popper: popperVariation
      }
    }),
    { provide: 'environment', useValue: environment },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: WafTokenInterceptor, multi: true },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', subscriptSizing: 'dynamic' } }
  ]
})
export class AppModule {
  constructor() {}
}
